/* RESPONSIBLE TEAM: team-fin-qa */
import ApplicationSerializer from '../application';

export default class TriggerableProcedureSerializer extends ApplicationSerializer {
  normalizeResponse(
    _store: any,
    primaryModelClass: any,
    payload: any,
    _id: any,
    _requestType: string,
  ) {
    return {
      data: (payload.procedures ?? []).map((p: any) => ({
        id: String(p.id),
        type: primaryModelClass.modelName,
        attributes: { name: p.name },
      })),
    };
  }
}
